export default [
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import('./Dashboard'),
    meta: {
      domain: 'Dashboard',
      sidebar: true,
      icon: 'dashboard',
      title: 'Dashboard',
    },
  },
];



// WEBPACK FOOTER //
// ./src/app/Dashboard/DashboardRouter.js